import React from 'react';

export const Blur = ({ children }: { children: React.ReactNode }) => (
  <span className="blurable block">{children}</span>
);
